export default "__VITE_ASSET__Ik0YT6E7__"